export default {
  agentList: [],
  paymentAccountList: []
};
